/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Reset_LabelInputs */



/**
* | output |
* | --- |
* | "Reset form fields" |
*
* @param {Event_Group_Metadata_Reset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_reset_label = /** @type {((inputs?: Event_Group_Metadata_Reset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Reset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser les champs du formulaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formularfelder zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta i campi del modulo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить поля формы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer campos de formulario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重置表单字段")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォームフィールドをリセットする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉर्म फ़ील्ड रीसेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Redefinir campos do formulário")
	return /** @type {LocalizedString} */ ("Reset form fields")
});